

var caseNews = {

    "caseNews": [
        {
            'name': 'Ningbo Fire Protection',
            'title': 'City-level Smart Fire Security System',
            'mes': 'Thanks to the deployment of SENSORO IoT Smart Fire Protection System, Ningbo’s firefighting team has improved the fire protection of thousands of crowded areas with a high fire risk, at low cost and within a tight timeframe. The new system has become a benchmark in the industry and is being taken as a model for fire protection systems.',
            'number': '83',
            'unit': '',
            'detail': 'Being the first IoT fire warning service in use in China, SENSORO Fire Protection System has already received 83 early fire warnings, breaking the barriers of traditional fire protection systems in complex places, and creating a new way of smart fire protection that combines both IoT technology and human firefighting teams.',
            'url': '/static/image/case/Ningbo-Fire-Protection@1x.jpg',
            'url1':'/static/image/case/Ningbo-Fire-Protection@2x.jpg'

        },
        {
            'name': 'Nanjing Fire Protection',
            'title': 'IoT Fire Protection System',
            'mes': 'Nanjing\'s Fire Station has introduced SENSORO\'s Smart Fire Protection System, which makes use of multi-sensor and long-distance IoT communication technology to provide early fire warnings, safeguarding people\'s lives and property.',
            'number': '60',
            'unit': 's',
            'detail': 'During the Chinese Lantern Festival celebrations, the number of visitors at Nanjing\'s Confucian Temple can exceed 600 000. Every 60 seconds, the SENSORO Smart Fire Protection System remotely monitored the changes in temperature, humidity, and flammable gases, protecting the life of thousands of visitors.',
            'url': '/static/image/case/Nanjing-Fire-Protection@1x.jpg',
            'url1': '/static/image/case/Nanjing-Fire-Protection@2x.jpg'
        },
        {
            'name': 'Potala Palace, Tibet',
            'title': 'Protecting a World Heritage Site on the snowy Tibetan plateau',
            'mes': 'SENSORO City Safety Service has overcome many difficulties to complete the fire protection of cultural relics and ancient buildings, and has created a new smart fire service model that protects these cultural treasures in the Tibetan region.',
            'number': '4000',
            'unit': '',
            'detail': 'SENSORO’s IoT signal has reached the snowy Tibetan plateau at an altitude of 4,000 meters. The city-level smart fire warning service has not only been deployed in the Potala Palace, but also in the Jokhang Temple and the Ramoche Temple in Lasha.',
            'url': '/static/image/case/Potala-Palace-Tibet@1x.jpg',
            'url1':'/static/image/case/Potala-Palace-Tibet@2x.jpg'

        },
        {
            'name': 'Yunding Ski Field ',
            'title': 'Opening of the Global Smart and Secure Winter Olympics',
            'mes': 'In 2022, the Winter Olympics will be held in China for the first time, and SENSORO\'s IoT Smart Fire Service will be deployed for this global event, building a smart and safe environment for the Olympics.',
            'number': '10000',
            'unit': '',
            'detail': 'Nearly 10,000 smart weatherproof SENSORO sensing devices and uninterrupted security monitoring will be used, integrating technology into this global sports event. SENSORO\'s Internet Intelligent Fire Service continues to expand in various industries, playing an increasingly valuable role for the community.',
            'url': '/static/image/case/Yunding-Ski-Field-@1x.jpg',
            'url1':'/static/image/case/Yunding-Ski-Field-@2x.jpg'

        },
        {
            'name': 'Forbidden City Museum',
            'title': 'Smart tour experience',
            'mes': 'In 2016, Beijing\'s Forbidden City Museum made use of SENSORO equipment to establish a comprehensive sensor network that enabled the access of information about visitors and museum collections at any time, anywhere, creating a smart museum experience for tourists.',
            'number': '100',
            'unit': '%',
            'detail': 'This is a significant breakthrough in the way traditional museums work, with the deployment of sensors visitors are able to obtain instant information of museum pieces as they approach them.  Without the need to configure special navigation tools, visitors can 100% autonomously know more about the museum collections,  having an enhanced stress-free experience.',
            'url': '/static/image/case/gugong@1x.jpg',
            'url1': '/static/image/case/gugong@2x.jpg'

        },
        {
            'name': 'Manchester, United Kingdom',
            'title': 'Real-time interaction',
            'mes': 'Manchester\'s buses, galleries, museums and libraries have deployed SENSORO IoT technology that enables users to obtain information about exhibitions and other events in real time.',
            'number': '"The Internet of Things system made in China revolutionizes the way people interact in places such as museums.',
            'unit': ' Christine Hitchins',
            'detail': ' Marketing & Digital manager of the Manchester Craft and Design Center',
            'url': '/static/image/case/Manchester-United-Kingdom@1x.jpg',
            'url1': '/static/image/case/Manchester-United-Kingdom@2x.jpg'
        },
        {
            'name': 'China Art Palace',
            'title': 'Self-controlled energy saving',
            'mes': 'The SENSORO IoT system allows the China Art Palace to monitor the temperature, humidity, light, and air quality of its facilities and enables the real-time adjustment of its indoor environment.',
            'number': '16.6',
            'unit': 'thousand',
            'detail': 'SENSORO\'s Smart Building IoT Solution integrates multi-sensory, two-way communication technology to cover more than 166 000 square meters of the China Art Palace facilities, achieving smart building energy management and control.',
            'url': '/static/image/case/ChinaArt@1x.jpg',
            'url1': '/static/image/case/ChinaArt@2x.jpg'

        },
        {
            'name': 'China High-Speed Rail',
            'title': 'Enhanced travel experience',
            'mes': 'For the first time, China\'s high-speed rail adopts low-power sensor technology to provide passengers with different kinds of voucher information, completely revolutionizing the traditional advertising model and creating a new marketing environment for high-speed trains.',
            'number': '560',
            'unit': 'million',
            'detail': 'SENSORO smart beacons have been deployed on 260 high-speed trains departing from Beijing every year, bringing a new experience to 560 million people and creating digital value and new passenger services.',
            'url': '/static/image/case/HighSpeedRail@1x.jpg',
            'url1': '/static/image/case/HighSpeedRail@2x.jpg'

        },
        {
            'name': 'CCTV',
            'title': 'Interaction with audience',
            'mes': 'China Central Television, in cooperation with China\'s National Tourism Administration, is able to interact real-time with its audience offline and collect their opinion on news leads thanks to the deployment of SENSORO location and information-based technology.',
            'number': '6',
            'unit': 'thousand',
            'detail': 'In May 2015, 4,200 Sensoro\'s iBeacon "Yunzi" were deployed in 40 of China\'s most popular scenic spots, covering 12 million visitors and collecting high-value information about the opinions of more than 60,000 visitors, which also helped to crack down on the illegal tourism market.',
            'url': '/static/image/case/CCTV@1x.jpg',
            'url1': '/static/image/case/CCTV@2x.jpg'

        },
        {
            'name': 'Real Madrid FC',
            'title': 'Digital transformation of sports',
            'mes': 'In 2015, Real Madrid Football Club had its first experience using SENSORO\'s sensor technology, creating a digital platform to provide fans with a simplified digital experience at the stadium.',
            'number': '10',
            'unit': 'million',
            'detail': 'Hundreds of SENSORO Bluetooth sensors were deployed in Guangzhou Tianhe Stadium and Shanghai Stadium. Thousands of Real Madrid fans took part in more than 10 million digital interactions.',
            'url': '/static/image/case/Real-Madrid-FC@1x.jpg',
            'url1': '/static/image/case/Real-Madrid-FC@2x.jpg'
        },

    ],
    "caseIcons":[
        {
            'iconTitle':'guobo',
            'iconUrl':'/static/image/case/icons/guobo@1x.png',
            'iconUrl1':'/static/image/case/icons/guobo@2x.png'
        },
        {
            'iconTitle':'gugong',
            'iconUrl':'/static/image/case/icons/gugong@1x.png',
            'iconUrl1':'/static/image/case/icons/gugong@2x.png'
        },
        {
            'iconTitle':'cctv',
            'iconUrl':'/static/image/case/icons/cctv@1x.png',
            'iconUrl1':'/static/image/case/icons/cctv@2x.png'
        },
        {
            'iconTitle':'audi',
            'iconUrl':'/static/image/case/icons/audi@1x.png',
            'iconUrl1':'/static/image/case/icons/audi@2x.png'
        },
        {
            'iconTitle':'imax',
            'iconUrl':'/static/image/case/icons/imax@1x.png',
            'iconUrl1':'/static/image/case/icons/imax@2x.png'
        },
        {
            'iconTitle':'m$',
            'iconUrl':'/static/image/case/icons/microsoft@1x.png',
            'iconUrl1':'/static/image/case/icons/microsoft@2x.png'
        },
        {
            'iconTitle':'sony',
            'iconUrl':'/static/image/case/icons/sony@1x.png',
            'iconUrl1':'/static/image/case/icons/sony@2x.png'
        },
        {
            'iconTitle':'crh',
            'iconUrl':'/static/image/case/icons/crh@1x.png',
            'iconUrl1':'/static/image/case/icons/crh@2x.png'
        }
    ]
};
var aboutmsg={
    aboutIcons:[
        {
            'iconUrl':'/static/image/about/icons/reddot@1x.png',
            'iconUrl1':'/static/image/about/icons/reddot@2x.png'
        },
        {
            'iconUrl':'/static/image/about/icons/idea@1x.png',
            'iconUrl1':'/static/image/about/icons/idea@2x.png'
        },
        {
            'iconUrl':'/static/image/about/icons/50fastest@1x.png',
            'iconUrl1':'/static/image/about/icons/50fastest@2x.png'
        },
        {
            'iconUrl':'/static/image/about/icons/henry@1x.png',
            'iconUrl1':'/static/image/about/icons/henry@2x.png'
        },
        {
            'iconUrl':'/static/image/about/icons/if@1x.png',
            'iconUrl1':'/static/image/about/icons/if@2x.png'
        }
    ],
    partnermsg:[
        {
            'iconUrl':'/static/image/about/icons/microsoft@1x.png',
            'iconUrl1':'/static/image/about/icons/microsoft@2x.png',
            'msg':'SENSORO is one of the few high-tech companies that receive Microsoft’s support globally and is also a member of Microsoft Ventures High Potential Program. SENSORO and Microsoft are cooperating as close partners in different regions around the world.'
        },
        {
            'iconUrl':'/static/image/about/icons/eddystone@1x.png',
            'iconUrl1':'/static/image/about/icons/eddystone@2x.png',
            'msg':'Eddystone is an open beacon format developed by Google, SENSORO is  Google Eddystone Asia\'s only official partner.'
        },
        {
            'iconUrl':'/static/image/about/icons/sony@1x.png',
            'iconUrl1':'/static/image/about/icons/sony@2x.png',
            'msg':'Sony and SENSORO are close strategic partners in the development of IoT technologies.'
        },
        {
            'iconUrl':'/static/image/about/icons/bosch@1x.png',
            'iconUrl1':'/static/image/about/icons/bosch@2x.png',
            'msg':'BOSCH and SENSORO are close strategic partners in the areas of sensor technology, artificial intelligence, machine vision, and intelligent security.'
        },
        {
            'iconUrl':'/static/image/about/icons/nokia@1x.png',
            'iconUrl1':'/static/image/about/icons/nokia@2x.png',
            'msg':'Nokia\'s global communications experts and SENSORO\'s R&D team maintain long-term and deep cooperation on IoT technology. Nokia’s team of experts fully supports the construction of SENSORO city-level IoT infrastructure and is responsible for the optimization of SENSORO\'s wireless communication network.'
        },
    ]
}

module.exports = {
    caseNews: caseNews,
    aboutmsg:aboutmsg

}



// WEBPACK FOOTER //
// ./src/assets/js/case.js